import React from 'react'
import Link from 'next/link'
import { getSlug } from '@/lib/utilities/Utils'

interface BreadcrumbProps {
  country: string | null
  city?: string | null
  locality?: string | null
  storeType?: string | null
  shopUrl?: string | null
  shopName?: string | null
  hasSeoData?: boolean
  cityTitle?: string | null
  localityTitle?: string | null
  countryTitle?: string | null
  storeTypeTitle?: string | null
  isCategorySelected?: string
  isLocalityPage?: boolean
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  country,
  city,
  locality,
  storeType,
  shopUrl,
  shopName,
  hasSeoData = false,
  cityTitle,
  localityTitle,
  countryTitle,
  storeTypeTitle,
  isLocalityPage = false
}) => {
  return (
    <div className="container mx-auto px-0 sm:px-4 py-3 pr-0 relative">
      <nav className="flex items-center gap-1 overflow-hidden whitespace-nowrap text-xs text-black/70">
        <Link
          href="/"
          className="flex-shrink-0 hover:underline"
        >
          Home
        </Link>

        {city !== undefined &&
          city !== null &&
          city !== '' &&
          cityTitle !== undefined &&
          cityTitle !== null &&
          cityTitle !== '' && (
            <>
              <span className="flex-shrink-0">/</span>
              <Link
                href={`/${getSlug(city)}?storeCategory=${getSlug(storeType ?? 'fruits-vegetables-shops')}`}
                className="truncate hover:underline w-auto"
                title={cityTitle}
              >
                {cityTitle}
              </Link>
            </>
        )}

        {locality !== undefined &&
          locality !== null &&
          locality !== '' &&
          localityTitle !== undefined &&
          localityTitle !== null &&
          localityTitle !== '' && (
            <>
              <span className="flex-shrink-0">/</span>
              <Link
                href={
                  isLocalityPage
                    ? `/${getSlug(city)}/${getSlug(locality)}`
                    : `/${getSlug(city)}/${getSlug(locality)}/${getSlug(storeType ?? 'fruits-vegetables-shops')}`
                }
                className="truncate hover:underline w-auto"
                title={localityTitle}
              >
                {localityTitle}
              </Link>
            </>
        )}

        {storeType !== undefined &&
          storeType !== null &&
          storeType !== '' && (
            <>
              <span className="flex-shrink-0">/</span>
              {
                isLocalityPage
                  ? (
                      <span
                        className="truncate w-auto text-pink-600 font-bold"
                        title={storeTypeTitle ?? storeType}
                      >
                        {storeTypeTitle ?? storeType}
                      </span>
                    )
                  : (
                      <Link
                        href={`/${getSlug(city)}/${getSlug(locality)}/${getSlug(storeType)}`}
                        className="truncate hover:underline w-auto"
                        title={storeTypeTitle ?? storeType}
                      >
                        {storeTypeTitle ?? storeType}
                      </Link>
                    )
              }
            </>
        )}

        {shopUrl !== undefined &&
          shopUrl !== null &&
          shopUrl !== '' &&
          shopName !== undefined &&
          shopName !== null &&
          shopName !== '' && (
            <>
              <span className="flex-shrink-0">/</span>
              <p
                className="flex-1 min-w-[80px] truncate font-medium text-black"
                title={shopName}
              >
                {shopName}
              </p>
            </>
        )}
      </nav>
    </div>
  )
}

export default Breadcrumb
